import { render, staticRenderFns } from "./deletePet.vue?vue&type=template&id=3d2f1354"
import script from "./deletePet.vue?vue&type=script&lang=js"
export * from "./deletePet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports